<script setup>
import { gsap } from 'gsap'
import TextFallDown from './full_text_animations/TextFallDown.vue'
import TextJumpAndLeave from './full_text_animations/TextJumpAndLeave.vue'
import TextTripleSlide from './full_text_animations/TextTripleSlide.vue'
import TextTwoLineRevealToBottomBar from './full_text_animations/TextTwoLineRevealToBottomBar.vue'
import TextSlideUp from './text_animations/TextSlideUp.vue'
import CharacterEnlarge from './text_animations/CharacterEnlarge.vue'

const props = defineProps({
  item: Object,
})

const title = computed(() => props.item.enrichment?.track?.title?.toUpperCase())
const artist = computed(() => props.item.enrichment?.track?.artist?.name)
const activeEdition = computed(() => props.item.enrichment.track.activeEditions?.[0])

const timeline = ref(null)

const timelineA = ref(null)
const timelineB = ref(null)
const timelineC = ref(null)
const timelineD = ref(null)

const timelineLineChartPosition = ref(null)
const timelineLineChartPositionOut = ref(null)
const timelineLineChartTitle = ref(null)

onMounted(() => {
  timeline.value = gsap
    .timeline({ smoothChildTiming: true }) // `smoothChildTiming` allows reversing the chart title timeline.
    .add(timelineA)
    .add(timelineB)
    .add(timelineC)
    .add(timelineD)
    .add(timelineLineChartPosition, '<1.20')
    .add(timelineLineChartTitle, '<')
    .add(timelineLineChartPositionOut.value?.(), '-=.64')
    .add(() => timelineLineChartTitle.value?.reverse(), '<')

  useDebugStore().add('Clip Intro', timeline.value)
})
</script>

<template>
  <div class="w-full h-full relative">
    <TextFallDown :text="artist" @timeline="timelineA = $event" />
    <TextJumpAndLeave :text="artist" @timeline="timelineB = $event" />
    <TextTripleSlide :text="title" @timeline="timelineC = $event" />
    <TextTwoLineRevealToBottomBar :textA="title" :textB="artist" @timeline="timelineD = $event" />
    <div v-if="activeEdition" class="text-right p-safe absolute z-10 bottom-0 right-0">
      <TextSlideUp
        :text="`#${activeEdition.position}`"
        class="text-q-cr-red-primary font-cervo font-bold text-[50px] -mb-1"
        @timeline="timelineLineChartPosition = $event"
        @timelineOut="timelineLineChartPositionOut = $event"
      />
      <CharacterEnlarge :text="activeEdition.list.name" class="text-white font-cervo font-bold text-[50px]" @timeline="timelineLineChartTitle = $event" />
    </div>
  </div>
</template>
